import {
  Calendar,
  Package,
  Shirt,
  Sparkles,
  UserCheck,
  Users
} from "lucide-react";
import React from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useNavigate } from "react-router-dom";
import MainHeader from "../Common/MainHeader/MainHeader";
import "./Dashboard.css";

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: "Produtos",
      description: "Gerencie seu estoque de produtos",
      icon: <Shirt size={28} />,
      color: "#6366F1",
      bgColor: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      path: "/produtos",
    },
    {
      title: "Clientes",
      description: "Cadastro  de clientes",
      icon: <Users size={28} />,
      color: "#10B981",
      bgColor: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
      path: "/clientes",
    },
    {
      title: "Reservas",
      description: "Controle de aluguéis e devoluções",
      icon: <Calendar size={28} />,
      color: "#F59E0B",
      bgColor: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      path: "/reservas",
    },
    {
      title: "Atendimentos",
      description: "Histórico de atendimentos",
      icon: <Package size={28} />,
      color: "#8B5CF6",
      bgColor: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      path: "/atendimento",
    },
    {
      title: "Funcionários",
      description: "Gerencie sua equipe de funcionários",
      icon: <UserCheck size={28} />,
      color: "#14B8A6",
      bgColor: "linear-gradient(135deg, #0ea5e9 0%, #14b8a6 100%)",
      path: "/funcionarios",
    },
    {
      title: "Devoluções",
      description: "Gerencie as devoluções de produtos",
      icon: <Package size={28} />,
      color: "#EF4444",
      bgColor: "linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)",
      path: "/devolucoes",
    },
  ];

  return (
    <div>
      <MainHeader
        title="Dashboard"
        subtitle="Gerencie seu negócio de aluguel de produtos"
        icon={<Sparkles size={32} />}
      />

      {/* Menu Principal - 3 cards em cima */}
      <Row className="g-4 mb-4">
        {menuItems.map((item, index) => (
          <Col key={index} xs={12} sm={6} lg={4}>
            <Card
              className="h-100 border-0 shadow-lg "
              style={{
                borderRadius: "20px",
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                cursor: "pointer",
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(20px)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
              }}
              onClick={() => navigate(item.path)}
            >
              <Card.Body className="p-4 text-center">
                <div
                  className="d-flex align-items-center justify-content-center rounded-4 mx-auto mb-3"
                  style={{
                    background: item.bgColor,
                    color: "white",
                    width: "80px",
                    height: "80px",
                    boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                  }}
                >
                  {item.icon}
                </div>
                <h5
                  className="mb-2"
                  style={{
                    color: "#1F2937",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                  }}
                >
                  {item.title}
                </h5>
                <p
                  className="text-muted mb-0"
                  style={{
                    fontSize: "14px",
                    lineHeight: "1.5",
                    fontWeight: "400",
                  }}
                >
                  {item.description}
                </p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Dashboard;
